export const LIST_FORCEDESKTOP = 'LIST_FORCEDESKTOP';